import { render } from "./EnvironmentSelect.vue?vue&type=template&id=28640044&scoped=true"
import script from "./EnvironmentSelect.vue?vue&type=script&lang=js"
export * from "./EnvironmentSelect.vue?vue&type=script&lang=js"

import "./EnvironmentSelect.vue?vue&type=style&index=0&id=28640044&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28640044"]])

export default __exports__